import React from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
const ServiceBenefitItem = ({
  headline = '',
  description = '',
  icon = ''
}) => /*#__PURE__*/React.createElement("div", {
  className: "ebds-service-benefit-item"
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-service-benefit-item__content"
}, /*#__PURE__*/React.createElement("h5", null, headline), /*#__PURE__*/React.createElement("p", null, description)), /*#__PURE__*/React.createElement("div", {
  className: "ebds-service-benefit-item__icon"
}, /*#__PURE__*/React.createElement(IconAsChunk, {
  iconName: icon
})));
export default ServiceBenefitItem;